export type NotificationModalType = 'Success' | 'Info' | 'Warning' | 'Error';
export const NotificationModalType = {
  success: 'Success' as NotificationModalType,
  info: 'Info' as NotificationModalType,
  warning: 'Warning' as NotificationModalType,
  error: 'Error' as NotificationModalType,
};
